const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js';

export interface MetaPixelFunction {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: MetaPixelFunction;
}

let initializedPixelId: string | null = null;

export const isMetaPixelEnabled = (): boolean =>
  window.runConfig?.nodeEnv === 'prod' && !!window.runConfig?.metaPixelId;

export const loadMetaPixel = (pixelId: string): void => {
  if (initializedPixelId === pixelId && window.fbq) {
    return;
  }

  if (!window.fbq) {
    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    } as MetaPixelFunction;

    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.push = fbq;

    window.fbq = fbq;
    if (!window._fbq) {
      window._fbq = fbq;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = FBEVENTS_SRC;
    document.head.appendChild(script);
  }

  window.fbq('init', pixelId);
  initializedPixelId = pixelId;
};

export const setMetaPixelConsent = (granted: boolean): void => {
  window.fbq?.('consent', granted ? 'grant' : 'revoke');
};

export const trackMetaPixelPageView = (): void => {
  window.fbq?.('track', 'PageView');
};

export const trackMetaPixelEvent = (
  name: string,
  params?: Record<string, unknown>
): void => {
  window.fbq?.('track', name, params);
};
